import { ItemZoneContextType } from '@context/ItemZoneContext'
import { Textures, TexturesGroup } from '@types'
import { API } from '@utils/queryBuilder'
import handleGroupClick from './handleGroupClick'

export default async function handleZoneClick(
  context: ItemZoneContextType,
  texture: Textures[number],
  force = false,
) {
  if (!force && context.currentTexture?.zoneName === texture.zoneName) {
    return
  }

  try {
    const response = await API().api.texturasGetGruposTexturas({
      catalogoName: 'Universales',
      version: '1',
      identificador: 1,
      universal: true,
      texto: context.searchValue,
    })

    const info: TexturesGroup[] = response.data

    context.setCenterInfo(info)
    context.setCurrentTexture(texture)
    context.setCopiedIconId('')

    // Asegurar que handleGroupClick se complete antes de continuar
    await handleGroupClick({ ...context, centerInfo: info }, texture.groupID, force)
  } catch (error) {
    console.error('❌ handleZoneClick: Error fetching texture groups:', error)
  }
}
